import React, { useEffect, useState } from "react";
import Layout from "../assets/Layout";
import UserLayout from "../assets/UserLayout";
import { Box, Grid, TextField, Typography } from "@mui/material";
import CandidateServiceCard from "../components/CandidateServiceCard";
import { useDispatch } from "react-redux";
import { getAllService } from "../actions/userAuth";

const CandidateServices = () => {
    const [services, setServices] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllService({}, (data) => {
            setServices(data.data.data);
        }));
    }, []);

    return (
        <>
            <Layout>
                <UserLayout>
                    <Box sx={{ display: 'flex', flexDirection: 'row', my: 8, borderRadius: '10px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Select Service</Typography>
                        {/* <TextField
                            // sx={{ background: '#3665D014', width: '70%', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)', }} // Updated style
                            variant="outlined"
                            size="small"
                            placeholder="Search"
                            onChange={handleSearch}
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                            }}
                        /> */}
                    </Box>
                    <Grid container spacing={2}>
                        {
                            services.map((item, index) => (
                                <Grid item md={6} key={index}>
                                    <CandidateServiceCard service={item} />
                                </Grid>
                            ))
                        }
                    </Grid>
                </UserLayout>
            </Layout>
        </>
    )
}

export default CandidateServices;